/* QMZ size-set: one-click "add 1 Sample piece per size" from the product page + quick-add modal.
   Full set = every size the product sells; Half set = every other size. Both lists are computed
   per-product by blocks/qmz-size-set.liquid and emitted on the card as data-qmz-full-sizes /
   data-qmz-half-sizes (JSON arrays), so any size scheme works (S–4XL, 30–44, 6–11, ...). Checking
   a box adds the sample pieces and toasts; unchecking removes them. Full/Half are mutually
   exclusive within a card. Variant map (normalized size -> sample variant id) is also emitted by
   the block. FULL/HALF below are only a fallback for old cached markup without the data-attrs. */
(function () {
  var FULL = ['S', 'M', 'L', 'XL', '2XL'];
  var HALF = ['S', 'L', '2XL'];

  function norm(s) { return String(s || '').toUpperCase().replace(/\s+/g, ''); }

  // Sizes for a set: prefer the per-card list the block computed; fall back to the globals.
  function sizesForSet(root, which) {
    var raw = which === 'half' ? root.getAttribute('data-qmz-half-sizes') : root.getAttribute('data-qmz-full-sizes');
    if (raw) {
      try {
        var arr = JSON.parse(raw);
        if (Array.isArray(arr) && arr.length) return arr;
      } catch (e) { /* fall through to defaults */ }
    }
    return which === 'half' ? HALF : FULL;
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'qmz-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('qmz-toast--show'); });
    setTimeout(function () {
      t.classList.remove('qmz-toast--show');
      setTimeout(function () { t.remove(); }, 300);
    }, 2600);
  }

  // Map of available sample variants for a card: { normalizedSize: variantId }.
  function variantMap(root) {
    var tag = root.querySelector('[data-qmz-size-set-variants]');
    if (!tag) return {};
    var arr;
    try { arr = JSON.parse(tag.textContent); } catch (e) { return {}; }
    var map = {};
    arr.forEach(function (v) { if (v && v.available !== false) map[norm(v.size)] = v.id; });
    return map;
  }

  function idsForSet(root, which) {
    var map = variantMap(root);
    var sizes = sizesForSet(root, which);
    var ids = [];
    sizes.forEach(function (sz) { var k = norm(sz); if (map[k]) ids.push(map[k]); });
    return ids;
  }

  function announceCart(cart, sourceId) {
    // Update the cart icon/contents WITHOUT auto-opening the drawer. The drawer opens on
    // 'cart:update' when it has auto-open; the theme's own B2B guard suppresses that for a
    // short window, so we set it right before dispatching (same behaviour as a variant add).
    window.__qmzQuickAddClosedAt = Date.now();
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: sourceId, data: { itemCount: cart && cart.item_count, source: 'qmz-size-set' } },
    }));
  }

  // The add-to-cart button in the same product form (product page or quick-add modal).
  function addButton(root) {
    var scope = root.closest('product-information, .quick-add-modal__content, #quick-add-modal-content, .shopify-section') || document;
    return scope.querySelector('add-to-cart-component button[name="add"], button[name="add"]');
  }

  // Briefly flash "Size Set Added" on the Add-to-cart button, then revert — mimics the
  // theme's transient "Added" state on a normal variant add.
  function flashButton(root) {
    var btn = addButton(root);
    if (!btn) return;
    var el = btn.querySelector('.add-to-cart-text__content') || btn.querySelector('.add-to-cart-text');
    if (!el) return;
    if (el.__qmzOrig == null) el.__qmzOrig = el.textContent;
    clearTimeout(el.__qmzTimer);
    el.textContent = 'Size Set Added';
    el.__qmzTimer = setTimeout(function () { el.textContent = el.__qmzOrig; }, 2500);
  }

  async function currentCart() {
    try { return await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); }
    catch (e) { return null; }
  }

  async function addSet(root, cb, which) {
    var ids = idsForSet(root, which);
    if (!ids.length) { toast('No sample sizes available for this set.'); cb.checked = false; return; }
    cb.disabled = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }),
      });
      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || 'Some items could not be added.');
      }
      cb.setAttribute('data-qmz-added', ids.join(','));
      announceCart(await currentCart(), 'qmz-size-set');
      flashButton(root);
      toast(which === 'half' ? 'Half size set added to cart' : 'Size set added to cart');
    } catch (e) {
      cb.checked = false;
      toast(e.message || 'Could not add size set.');
    } finally {
      cb.disabled = false;
    }
  }

  async function removeSet(root, cb, silent) {
    var stored = cb.getAttribute('data-qmz-added');
    cb.removeAttribute('data-qmz-added');
    if (!stored) return;
    var updates = {};
    stored.split(',').forEach(function (id) { updates[id] = 0; });
    cb.disabled = true;
    try {
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      announceCart(await res.json(), 'qmz-size-set');
      if (!silent) toast('Size set removed from cart');
    } catch (e) {
      if (!silent) toast('Could not remove size set.');
    } finally {
      cb.disabled = false;
    }
  }

  function onChange(e) {
    var cb = e.target.closest && e.target.closest('[data-qmz-size-set-cb]');
    if (!cb) return;
    var root = cb.closest('[data-qmz-size-set]');
    if (!root) return;
    var which = cb.getAttribute('data-qmz-size-set-cb'); // 'full' | 'half'
    if (cb.checked) {
      // Full and Half are mutually exclusive within a card — clear the other first.
      root.querySelectorAll('[data-qmz-size-set-cb]').forEach(function (other) {
        if (other !== cb && other.checked) { other.checked = false; removeSet(root, other, true); }
      });
      addSet(root, cb, which);
    } else {
      removeSet(root, cb);
    }
  }

  document.addEventListener('change', onChange);

  // Keep checkbox state honest: if a set's pieces are no longer in the cart (e.g. removed
  // manually, or a foreign cart change), untick it. Skips our own updates to avoid loops.
  async function reconcile() {
    var boxes = document.querySelectorAll('[data-qmz-size-set-cb][data-qmz-added]');
    if (!boxes.length) return;
    var cart = await currentCart();
    if (!cart || !cart.items) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.id] = true; });
    boxes.forEach(function (cb) {
      var ids = (cb.getAttribute('data-qmz-added') || '').split(',').filter(Boolean);
      var any = ids.some(function (id) { return inCart[id]; });
      if (!any) {
        cb.checked = false;
        cb.removeAttribute('data-qmz-added');
      }
    });
  }
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.data && e.detail.data.source === 'qmz-size-set') return;
    reconcile();
  });
})();
